import AudioRecorder from "audio-recorder-polyfill";
import mpegEncoder from "audio-recorder-polyfill/mpeg-encoder";
import { Controller } from '@hotwired/stimulus';
import { FetchRequest } from '@rails/request.js';

export default class extends Controller {
  connect() {
    AudioRecorder.encoder = mpegEncoder;
    AudioRecorder.prototype.mimeType = "audio/mpeg";
    window.MediaRecorder = AudioRecorder;

    const startButton = document.getElementById("family-start-recording-button");
    const stopButton = document.getElementById("family-stop-recording-button");
    const deleteButton = document.getElementById("family-delete-recording-button");
    const player = document.getElementById("player");

    let shouldStop = false;
    let stopped = false;
    let saved = false;
    var blob;

    startButton.addEventListener("click", function () {
      if (startButton.getAttribute("disabled") === "disabled") {
        return;
      }

      navigator.mediaDevices
        .getUserMedia({ audio: true, video: false })
        .then(startRecording);
    });

    stopButton.addEventListener("click", function () {
      if (stopButton.getAttribute("disabled") === "disabled") {
        return;
      }

      stopButton.setAttribute("disabled", "disabled");
      startButton.removeAttribute("disabled");
      shouldStop = true;
    });

    deleteButton.addEventListener("click", function () {
      if (deleteButton.getAttribute("disabled") === "disabled") {
        return;
      }

      var formData = new FormData();
      formData.append(deleteButton.dataset.inputName, "delete");
      new FetchRequest('post', deleteButton.dataset.apiUrl, { body: formData })
        .perform()
        .then(() => {
          deleteButton.removeAttribute("disabled");
          player.removeAttribute("controls");
        });
    });

    function startRecording(stream) {
      const recordedChunks = [];
      const mediaRecorder = new MediaRecorder(stream);

      startButton.setAttribute("disabled", "disabled");
      stopButton.removeAttribute("disabled");
      shouldStop = false;
      stopped = false;
      saved = false;

      mediaRecorder.addEventListener("dataavailable", (e) => {
        if (e.data.size > 0) {
          recordedChunks.push(e.data);
        }

        if (shouldStop && !stopped) {
          mediaRecorder.stop();
          mediaRecorder.stream.getTracks().forEach((i) => i.stop());
          stopped = true;
        }
      });
      mediaRecorder.start(1000);

      function bufferToDataUrl() {
        if (saved) {
          return;
        }
        blob = new Blob(recordedChunks, {
          type: "audio/mpeg"
        });
        var audioURL = URL.createObjectURL(blob);
        player.src = audioURL;
        player.controls = true;
        saveRecording();
      }

      function saveRecording() {
        var formData = new FormData();
        formData.append(stopButton.dataset.inputName, blob);
        new FetchRequest('post', stopButton.dataset.apiUrl, { body: formData })
          .perform()
          .then(() => {
            deleteButton.removeAttribute("disabled");
          });
        saved = true;
      }

      mediaRecorder.addEventListener("stop", function () {
        bufferToDataUrl();
      });
    }
  }
}
